// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"296c997c","769":"78baacaf"}[chunkId] + ".chunk.js";
};